import Head from "next/head";
import { buildFaqSchema } from "@/lib/seo/faqSchema";

/**
 * Emits FAQPage JSON-LD for whatever Q&A the page renders.
 *
 * Feed it server-fetched data (getServerSideProps / getStaticProps) rather than
 * state filled in by useEffect — most AI crawlers don't run JavaScript, so
 * client-injected markup is invisible to them.
 */
const FaqSchema = ({ items, id }) => {
  const schema = buildFaqSchema(items, { id });
  if (!schema) return null;

  return (
    <Head>
      <script
        type="application/ld+json"
        key={id ? `faq-schema-${id}` : "faq-schema"}
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </Head>
  );
};

export default FaqSchema;
